module.exports = __webpack_public_path__ + "static/img/ydbg3@2x.c046494.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ydbg3@2x.png
// module id = e7I/
// module chunks = 1